import * as actions from './actions';
import reducers from './reducer';

export const Video = { actions, reducers };
export { VideoState } from './reducer';
